jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.signposting').length ) {
        let $ = jQuery;

        if($('.signposts').hasClass('four')){
            var count = 4;
        } else{
            var count = 3;
        }

        $(".signposting .signposts:not(.no-slick)").slick({
            // centerMode: true,
            // centerPadding: '40px',
            slidesToShow: count,
            slidesToScroll: 1,
            rows: 0,
            dots: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        autoplay: true,
                        autoplaySpeed: 5000,
                        centerMode: false,
                        slidesToShow: 1,
                        infinite: true,
                    }
                }
            ]
        })

    }
});